/**
 * Import all JavaScript
 */
import allJs from "./js/index";
allJs();

/**
 * Import all images
 */
import allImages from "./images/index";
allImages();

/**
 * Import Sass/Scss
 */
import "./sass/index.scss";



// WEBPACK FOOTER //
// ./assets/src/site.js